import { Tooltip } from 'components'
import styles from './eldProviderCell.module.scss'
import strings from 'strings'


const t = strings.TABLE_DEFAULTS

export const EldProviderCell: React.FC<{
  eldProviderNames: string[]

}> = ({ eldProviderNames }) => {
  if (!eldProviderNames || eldProviderNames.length === 0) {
    return (
      <div className={styles.emptyState}>
        <span>{t.DASH_VALUE}</span>
      </div>
    )
  }

  return (
    <div className={styles.container}>
      {eldProviderNames.map((eldProviderName, index) => {
        const fullDisplayText = `${eldProviderName}`

        return (
          <div
            key={`${eldProviderName}-${index}`}
            className={styles.eldProviderItem}
          >
            <Tooltip title={fullDisplayText} containerClassName="ellipsis">
              <span>
                <span className={styles.eldProviderName}>{eldProviderName}</span>
              </span>
            </Tooltip>
          </div>
        )
      })}
    </div>
  )
}